import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bar from '../common/graphs/bar';
import Graph from './evolutionGraph.jsx';
import GraphBar from './evolutionGraphBar.jsx';

const calc = theform => {
  let num = theform;
  if (num) {
    let with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0];
    return with2Decimals;
  }
  return 0;
};

const position = obj => {
  if (obj.value || obj.value > 0) {
    let total = 97 * obj.value;
    total /= obj.total;
    total += -40;
    return total;
  }
  return -40;
};

const SummaryMain = props => (
  <section
    onClick={props.link}
    className={
      props.categorizationSeverity
        ? `main_summary ${props.categorizationSeverity}`
        : 'main_summary OUTOFRISK'
    }
  >
    <div className="main_summary_graph">
      <span className="left_graph_title">
        <h2>{props.language.summary.title.microSleep}</h2>
      </span>
      <div className="main_summary_graph__color">
        <a data-tags={false}>
          {props.dailyWarningRate.length > 0 && (
            <Graph
              tooltip={props.language.driver_roadwarning.labels}
              graphColorRange={props.graphColorRange}
              data={props.dailyWarningRate}
              id="test1"
              language={props.language}
            />
          )}
          <div
            className="main_summary_num"
            style={{
              bottom: position({
                total: 100,
                value: calc(props.warningRate)
              })
            }}
          >
            <h4 className={props.categorizationSeverity}>
              {props.warningRate ? calc(props.warningRate) : '0'}{' '}
            </h4>
            <p>{props.language.driver_roadwarning.labels.microSleep}</p>
            <p>{props.language.driver_roadwarning.labels.drivingOurs}</p>
          </div>
        </a>
      </div>
    </div>
    <div className="main_summary_graph main_summary_graph_right">
      <span className="right_graph_title">
        <h2>{props.language.summary.title.microSleepBar}</h2>
      </span>
      <div className="main_summary_graph__color">
        <a className="normal" data-tags={false}>
          {props.dailyWarningFrequency.length > 0 && (
            <GraphBar
              data={props.dailyWarningFrequency}
              tooltip={props.language.driver_roadwarning.labels.evolutionGraphBarTooltip}
              language={props.language}
            />
          )}
        </a>
      </div>
    </div>
  </section>
);

export default SummaryMain;



// WEBPACK FOOTER //
// ./source/client/components/summary_roadwarning/summaryMain.jsx